'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promises = {
    init: function init(params) {
        return new Promise(function (resolve) {
            if (typeof FB !== 'undefined') {
                resolve();
            } else {
                window.fbAsyncInit = function () {
                    FB.init({
                        appId: params.appId,
                        cookie: true, // enable cookies to allow the server to access the session
                        xfbml: true, // parse social plugins on this page
                        version: params.version || 'v2.5' // use version 2.5
                    });
                    resolve();
                };
                (function (d, s, id) {
                    var fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    var js = d.createElement(s);js.id = id;
                    js.src = '//connect.facebook.net/en_US/sdk.js';
                    fjs.parentNode.insertBefore(js, fjs);
                })(document, 'script', 'facebook-jssdk');
            }
        });
    },
    checkLoginState: function checkLoginState() {
        return new Promise(function (resolve, reject) {
            FB.getLoginStatus(function (response) {
                response.status === 'connected' ? resolve(response) : reject(response);
            });
        });
    },
    login: function login() {
        return new Promise(function (resolve, reject) {
            FB.login(function (response) {
                response.status === 'connected' ? resolve(response) : reject(response);
            });
        });
    },
    logout: function logout() {
        return new Promise(function (resolve, reject) {
            FB.logout(function (response) {
                response.authResponse ? resolve(response) : reject(response);
            });
        });
    },
    fetchUser: function fetchUser() {
        return new Promise(function (resolve, reject) {
            FB.api('/me', { fields: 'first_name, last_name, gender' }, function (response) {
                return response.error ? reject(response) : resolve(response);
            });
        });
    }
};

var FBCallback = {
    _callback: function _callback(callback, newProps) {
        this.result = _lodash2.default.extend(this.result, newProps || {});
        callback(this.result);
    },
    init: function init(params, callback) {
        var _this = this;

        this.result = { loading: true, data: undefined, status: 'unknown', error: undefined };
        this._callback(callback);
        promises.init(params).then(function (response) {
            _this._callback(callback, { status: 'init' });
        }, function (error) {
            throw error;
        }).catch(function (error) {
            _this._callback(callback, { loading: false, status: 'unknown', error: error });
            console.warn(error);
        });
    },
    login: function login(params, callback) {
        var _this2 = this;

        this.result = { loading: true, data: undefined, status: 'unknown', error: undefined };
        this._callback(callback);
        promises.init(params).then(promises.checkLoginState, function (error) {
            throw error;
        }).then(function (response) {
            _this2._callback(callback, { status: response.status });
        }, promises.login).then(function (response) {
            _this2._callback(callback, { status: response ? response.status : _this2.result.status });
        }, function (error) {
            throw error;
        }).then(promises.fetchUser, function (error) {
            throw error;
        }).then(function (response) {
            _this2._callback(callback, { loading: false, data: response });
        }, function (error) {
            throw error;
        }).catch(function (error) {
            _this2._callback(callback, { loading: false, data: undefined, status: 'unknown', error: error });
            console.warn(error);
        });
    },
    logout: function logout(params, callback) {
        var _this3 = this;

        this.result = { loading: true, data: undefined, status: 'unknown', error: undefined };
        this._callback(callback);
        promises.init(params).then(promises.checkLoginState, function () {
            _this3._callback(callback, { loading: false, data: undefined, status: 'unknown' });
        }).then(promises.logout, function (response) {
            _this3._callback(callback, { data: undefined, status: response.status, error: undefined });throw undefined;
        }).then(function (response) {
            _this3._callback(callback, { loading: false, status: response.status, data: undefined });
        }, function (error) {
            throw error;
        }).catch(function (error) {
            if (error !== undefined) {
                _this3._callback(callback, { loading: false, data: undefined, status: 'unknown', error: error });
                console.warn(error);
            } else {
                _this3._callback(callback, { loading: false });
            }
        });
    },
    checkStatus: function checkStatus(params, callback) {
        var _this4 = this;

        this.result = { loading: true, data: undefined, status: 'unknown', error: undefined };
        this._callback(callback);
        promises.init(params).then(promises.checkLoginState, function (error) {
            throw error;
        }).then(function (response) {
            _this4._callback(callback, { status: response.status });
        }, function (response) {
            _this4._callback(callback, { loading: false, status: response.status });throw undefined;
        }).then(promises.fetchUser, function (error) {
            throw error;
        }).then(function (response) {
            _this4._callback(callback, { loading: false, data: response });
        }, function (error) {
            throw error;
        }).catch(function (error) {
            if (error !== undefined) {
                _this4._callback(callback, { loading: false, data: undefined, status: 'unknown', error: error });
                console.warn(error);
            } else {
                _this4._callback(callback, { loading: false });
            }
        });
    }
};

exports.default = {
    callback: FBCallback
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/facebook-login-promises/lib/index.js
// module id = E22v
// module chunks = 0